export default "__VITE_ASSET__D6j8H2pl__"